import { Component, Element, h, Prop } from '@stencil/core';

@Component({
	shadow: false,
	styleUrl: 'zds-form-label.scss',
	tag: 'zds-form-label',
})
export class ZdsFormLabel {
	@Element() hostElement: HTMLElement;

	@Prop() htmlFor: string;
	@Prop() tag: string = 'label';

	render() {
		const ComponentTag = this.tag;

		return (
			<ComponentTag class="zds-form-label" htmlFor={this.htmlFor}>
				<slot />
			</ComponentTag>
		);
	}
}
